export default __webpack_public_path__ + "static/media/Events.095aad3f.svg";